import { render, staticRenderFns } from "./FacIntro.vue?vue&type=template&id=73549a1e&scoped=true&"
import script from "./FacIntro.vue?vue&type=script&lang=js&"
export * from "./FacIntro.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=73549a1e&prod&scoped=true&lang=css&"
import style1 from "./FacIntro.vue?vue&type=style&index=1&id=73549a1e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73549a1e",
  null
  
)

export default component.exports